"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongRunningDescriptor = void 0;

var longRunningApiCaller_1 = require("./longRunningApiCaller");
/**
 * A descriptor for long-running operations.
 */


var LongRunningDescriptor =
/*#__PURE__*/
function () {
  function LongRunningDescriptor(operationsClient, responseDecoder, metadataDecoder) {
    _classCallCheck(this, LongRunningDescriptor);

    this.operationsClient = operationsClient;
    this.responseDecoder = responseDecoder;
    this.metadataDecoder = metadataDecoder;
  }

  _createClass(LongRunningDescriptor, [{
    key: "getApiCaller",
    value: function getApiCaller() {
      return new longRunningApiCaller_1.LongrunningApiCaller(this);
    }
  }]);

  return LongRunningDescriptor;
}();

exports.LongRunningDescriptor = LongRunningDescriptor;